import { supabase } from '@/lib/supabase';

export type PeriodType = 'monthly' | 'quarterly' | 'yearly';

export interface KpiAnomaly {
  period: string;
  period_type: PeriodType;
  aggregated_value: number;
  is_anomaly: boolean;
  forecast_value: number | null;
  upper_bound: number | null;
  lower_bound: number | null;
  deviation_percentage: number | null;
  period_start: string;
  period_end: string;
  project_name: string;
  org_name: string | null;
  org_picture_url: string | null;
}

export interface DetectKpiAnomaliesParams {
  kpiId: number;
  projectId: number;
  monthsBack?: number;
  periodType?: PeriodType;
  fromDate?: Date;
  toDate?: Date;
}

export async function detectKpiAnomalies({
  kpiId,
  projectId,
  monthsBack = 12,
  periodType = 'monthly',
  fromDate,
  toDate,
}: DetectKpiAnomaliesParams): Promise<KpiAnomaly[]> {
  const { data, error } = await supabase.rpc('detect_kpi_anomalies', {
    p_kpi_id: kpiId,
    p_project_id: projectId,
    p_months_back: fromDate || toDate ? undefined : monthsBack,
    p_period_type: periodType,
    p_from_date: fromDate?.toISOString(),
    p_to_date: toDate?.toISOString(),
  });

  if (error) {
    throw error;
  }

  return (data ?? []) as KpiAnomaly[];
}
